import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Form, Modal } from 'react-bootstrap';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import axios from 'axios';

const GymPackages = () => {
  const [packages, setPackages] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({ name: '', duration: '', price: '', description: '' });
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      const res = await axios.get('/api/gym/packages');
      setPackages(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await axios.put(`/api/gym/packages/${editId}`, formData);
      } else {
        await axios.post('/api/gym/packages', formData);
      }
      setShowModal(false);
      setFormData({ name: '', duration: '', price: '', description: '' });
      setEditId(null);
      fetchPackages();
    } catch (err) {
      console.error(err);
    }
  };

  const handleEdit = (pkg) => {
    setFormData(pkg);
    setEditId(pkg.id);
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('Delete this package?')) {
      try {
        await axios.delete(`/api/gym/packages/${id}`);
        fetchPackages();
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <Container fluid className="py-4">
      <Row className="mb-4">
        <Col><h2>📦 Gym Packages</h2></Col>
        <Col xs="auto">
          <Button variant="success" onClick={() => { setShowModal(true); setEditId(null); setFormData({ name: '', duration: '', price: '', description: '' }); }}>
            <FaPlus className="me-2" /> Add Package
          </Button>
        </Col>
      </Row>

      <Card className="shadow-sm">
        <Card.Body>
          <Table responsive hover>
            <thead>
              <tr>
                <th>Package Name</th>
                <th>Duration (Days)</th>
                <th>Price</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {packages.map((pkg) => (
                <tr key={pkg.id}>
                  <td><strong>{pkg.name}</strong></td>
                  <td>{pkg.duration} days</td>
                  <td>Rs. {pkg.price}</td>
                  <td>{pkg.description}</td>
                  <td>
                    <Button variant="outline-primary" size="sm" className="me-1" onClick={() => handleEdit(pkg)}><FaEdit /></Button>
                    <Button variant="outline-danger" size="sm" onClick={() => handleDelete(pkg.id)}><FaTrash /></Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{editId ? 'Edit' : 'Add'} Package</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Package Name</Form.Label>
              <Form.Control required value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Duration (Days)</Form.Label>
              <Form.Control type="number" required value={formData.duration} onChange={(e) => setFormData({ ...formData, duration: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Price</Form.Label>
              <Form.Control type="number" required value={formData.price} onChange={(e) => setFormData({ ...formData, price: e.target.value })} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control as="textarea" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
            </Form.Group>
            <Button type="submit" variant="success">Save</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default GymPackages;
